import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { HttpParams } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import {
    EnumSiNoTodos,
    TwTcTipoOrganismoNocivoViewModel,
    WOrganismosNocivosExtendedItemResultsViewModel,
    WOrganismosNocivosExtendedViewModel,
} from 'src/app/components/core/_infrastructure/types/common';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { Dialog } from 'primeng/dialog';
import { SelectItem } from 'primeng/api';
import { EnumTipoExentoCertificacionCpe } from '../../../../_importacion/solicitudes/types/enum';

@Component({
    selector: 'app-organismosnocivospopup',
    templateUrl: './organismosNocivosPopup.component.html',
})
export class OrganismosNocivosPopupComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    //@Input() isModeSelectionRowsCheckBoxes: boolean = false; //FALSE --> SINGLE (doble clic), TRUE --> MULTIPLE (checkboxes)
    listSiNoTodos: SelectItem[];
    resultOrganismosNocivos: WOrganismosNocivosExtendedItemResultsViewModel;
    TipoExento: EnumTipoExentoCertificacionCpe;
    OrigenCPE = false;
    display = false;
    //emit para grid en modo selección doble clic en la fila a seleccionar
    @Output() selectedEmitter: EventEmitter<WOrganismosNocivosExtendedViewModel> = new EventEmitter();
    //emit para grid en modo selección checkboxes en las filas a seleccionar
    //selectedArrayEmitter: EventEmitter<WBotanicaViewModel[]> = new EventEmitter();

    cols: any[];

    listTiposOrganismoNocivo: TwTcTipoOrganismoNocivoViewModel[];

    listTiposOrganismoNocivo$ = this.globalService.getTipoOrganismoNocivo().subscribe(params => {
        this.listTiposOrganismoNocivo = params;
    });

    selectedOrganismoNocivo: WOrganismosNocivosExtendedViewModel | null;
    //arraySelectedEspeciesEppo: WBotanicaViewModel[] = [];
    //modoConsulta: boolean = false;
    public isCollapsed = false;

    constructor(
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
    ) {
        super();
    }

    ngOnInit() {
        this.form = this.fb.group({
            DataType: '',
            Code: '',
            Preferred: EnumSiNoTodos.TODOS,
            FullName: '',
            RegulatedUe: EnumSiNoTodos.TODOS,
            NoEspecie: EnumSiNoTodos.TODOS,
        });
        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];
    }

    private createColsForTables(): void {
        if (this.OrigenCPE) {
            this.cols = [
                { field: 'Id', header: 'Id', display: 'none' },
                { field: 'DataType', header: 'Tipo de Organismos Nocivo' },
                { field: 'Code', header: 'Código EPPO' },
                { field: 'Preferred', header: 'Favorito' },
                { field: 'FullName', header: 'Nombre Completo' },
            ];
        } else {
            this.cols = [
                { field: 'Id', header: 'Id', display: 'none' },
                { field: 'DataType', header: 'Tipo de Organismos Nocivo' },
                { field: 'Code', header: 'Código EPPO' },
                { field: 'Preferred', header: 'Favorito' },
                { field: 'FullName', header: 'Nombre Completo' },
                { field: 'RegulatedUe', header: 'Regulado por la UE' },
                { field: 'NoEspecie', header: 'No Especie' },
            ];
        }
    }
    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = false;
    }

    Search(pageNumber: number, asc = 0, orderBy = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('dataType', this.form.value.DataType);
        params = params.append('code', this.form.value.Code);
        params = params.append('preferred', this.form.value.Preferred);
        params = params.append('status', 1);
        params = params.append('fullName', this.form.value.FullName);
        params = params.append('regulatedUe', this.form.value.RegulatedUe);
        params = params.append('noEspecie', this.form.value.NoEspecie);

        this.loading = true;

        this.globalService.getWOrganismosNocivosExtendedPagedByFilter(params).subscribe(result => {
            if (result) {
                this.selectedOrganismoNocivo = null;
                this.resultOrganismosNocivos = result;
                this.loading = false;
            }
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            DataType: '',
            Code: '',
            Preferred: EnumSiNoTodos.TODOS,
            FullName: '',
            RegulatedUe: EnumSiNoTodos.TODOS,
            NoEspecie: EnumSiNoTodos.TODOS,
        });

        this.selectedOrganismoNocivo = null;
        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultOrganismosNocivos = new WOrganismosNocivosExtendedItemResultsViewModel();
    }

    showDialog(tipoExento: string, EsCPE: boolean) {
        this.display = true;
        //están también en onCleanButton()
        //this.isCollapsed = false;
        //this.searchingButton = false;

        this.OrigenCPE = EsCPE;
        this.createColsForTables();

        switch (tipoExento) {
            case 'A':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_A;
                break;
            case 'B':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_B;
                break;
            case 'C':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_C;
                break;
            case 'D':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_D;
                break;
            case 'E':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_E;
                break;
            case 'F':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_F;
                break;
            case 'G':
                this.TipoExento = EnumTipoExentoCertificacionCpe.CHECK_EXENTO_G;
                break;

            default:
                break;
        }

        //borra datos introducidos en llamadas anteriores en campos del formulario
        this.onCleanButton();
    }

    //emit para grid en modo selección doble clic en la fila a seleccionar
    onRowDblClick(event: any, organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        this.display = false;
        this.searchingButton = false;

        this.selectedOrganismoNocivo = organismoNocivo;
        this.selectedOrganismoNocivo.TipoExento = this.TipoExento;

        this.selectedEmitter.emit(this.selectedOrganismoNocivo);
    }

    //emit para grid en modo selección checkboxes en las filas a seleccionar
    //emitArraySelectedEspeciesEppo(event: any, arraySelectedEspeciesEppo: WBotanicaViewModel[]) {
    //    this.display = false;
    //    this.searchingButton = false;

    //    //p-dialog es un contenedor que se oculta/muestra a demanda, por eso hay que borrar los datos obtenidos, ya que perduran.
    //    //Para que la siguiente vez al entrar no salgan marcados los checkbox en la tabla
    //    let arraySelectedEspeciesEppoNew = arraySelectedEspeciesEppo.slice();
    //    arraySelectedEspeciesEppo.splice(0, arraySelectedEspeciesEppo.length);
    //    this.selectedArrayEmitter.emit(arraySelectedEspeciesEppoNew);
    //}

    showDialogMaximized(dialog: Dialog) {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    acceptDialog() {
        this.display = false;

        this.selectedEmitter.emit(this.selectedOrganismoNocivo!);
    }

    cancelDialog() {
        this.display = false;
    }

    onSelect(selection: WOrganismosNocivosExtendedViewModel): void {
        this.selectedOrganismoNocivo = selection;
        this.selectedOrganismoNocivo.TipoExento = this.TipoExento;
    }

    noAccepted(): boolean {
        return !this.form.valid || this.selectedOrganismoNocivo === null;
    }
}
